import { useQuery } from '@tanstack/react-query';
import { usePaginationApi } from '../../../../shared/hooks';

interface Pagination {
  perPage: number;
  currentPage: number;
  searchTerm: string;
}

export interface Post {
  id: string;
  post_description: string;
  type: string;
  updated_at: string;
  is_public: boolean;
  is_hidden: boolean;
  created_at: string;
  user_id: string;
  location: string | null;
  media_url: string | null;
}

export const usePostsList = (pagination: Pagination) => {
  const { getWithPagination } = usePaginationApi();
  console.log('pagination ', pagination)
  return useQuery({
    queryKey: ["post-list", pagination],
    queryFn: async () => {
      const response = await getWithPagination("POST_SERVICE", "/api/post/admin/post", {
        perpage: pagination.perPage,
        page: pagination.currentPage,
        search: pagination.searchTerm,
      });

      console.log('response ', response)
      if (!response.status) {
        throw new Error(response.message || 'Failed to fetch posts');
      }

      const data = (response.data as any).data;
     

      return {
        data,
        pagination: response.pagination || {
          currentPage: 1,
          total: 0,
          totalPages: 0
        }
      };
    },
    keepPreviousData: true,
    staleTime: 5000, // Consider data fresh for 5 seconds
  });
};
